import { useState } from "react";
import { Landmark, Gift, Mail, Check, Copy } from "lucide-react";
import { ChapterTag, Reveal } from "./shared";

const ICONS = { bank: Landmark, registry: Gift, envelope: Mail };

function GiftCard({ icon, label, value, link }) {
  const Icon = icon;
  const [copied, setCopied] = useState(false);
  const copy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard?.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    });
  };
  const Wrapper = link ? "a" : "div";
  const wrapperProps = link ? { href: link, target: "_blank", rel: "noopener noreferrer" } : {};
  return (
    <Wrapper
      {...wrapperProps}
      data-testid={`gift-card-${label.replace(/\s+/g, "-").toLowerCase()}`}
      data-cursor="hover"
      className="group flex flex-col items-center rounded-2xl border border-ivory/15 bg-charcoal p-10 text-center transition-transform duration-500 hover:-translate-y-2"
    >
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full border border-gold/40">
        <Icon className="h-6 w-6 text-gold" strokeWidth={1.2} />
      </div>
      <p className="text-xs uppercase tracking-[0.3em] text-gold">{label}</p>
      <p className="mt-4 max-w-[16rem] break-words font-serif text-lg text-ivory/90">{value}</p>
      {link ? (
        <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-ivory/60 transition-colors group-hover:text-gold">
          Abrir mesa de regalos
        </span>
      ) : (
        <button
          onClick={copy}
          className="mt-6 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-ivory/50 transition-colors hover:text-gold"
        >
          {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
          {copied ? "Copiado" : "Copiar"}
        </button>
      )}
    </Wrapper>
  );
}

export default function Chapter8Gifts({ config }) {
  const { gifts } = config;
  return (
    <section className="relative bg-deep-black py-28 md:py-40" data-testid="chapter-8">
      <div className="mx-auto max-w-5xl px-6 md:px-16">
        <ChapterTag n={6} title="Con cariño" dark />
        <Reveal>
          <h2 className="mb-6 max-w-3xl font-serif text-4xl font-light leading-tight tracking-tight text-ivory md:text-5xl">
            Nuestro mejor regalo será celebrar este día tan especial <span className="italic text-gold">junto a ustedes</span>.
          </h2>
          <p className="mb-16 max-w-xl text-sm font-light leading-relaxed text-ivory/50">{gifts.note}</p>
        </Reveal>
        <div className="mx-auto max-w-xl">
          <GiftCard icon={ICONS.registry} label={gifts.registry.label} value={gifts.registry.value} link={gifts.registry.link} />
        </div>
      </div>
    </section>
  );
}
